export default function() {
  $(document).ready(function() {
    window.thinkwell.lib.inject('/account/login', '/accounts/login', '#customer_login');
  });
}
